import { RefObject } from 'react'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popover,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { IProfileUserResponse } from 'src/types'

import { isAccountOwner, joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { AccountBadgedIcon } from './account-badge-icon.component'

interface AccountsListPopoverProps {
  open: boolean
  handleClose: () => void
  anchorRef: RefObject<HTMLButtonElement | null>
  accounts: IProfileUserResponse['accounts']
}

const AccountsListPopover = ({
  anchorRef,
  handleClose,
  open,
  accounts,
}: AccountsListPopoverProps) => {
  const navigate = useNavigate()
  const handleNavigate = (id: string) => () =>
    navigate(joinAbsRoute(ROUTES.ACCOUNTS, id, ROUTES.DASHBOARD))

  return (
    <Popover
      open={open}
      anchorEl={anchorRef.current}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Paper>
        <List disablePadding>
          {accounts.map(({ account, roles, status }) => (
            <ListItem key={account.id} disableGutters disablePadding>
              <ListItemButton onClick={handleNavigate(account.id)}>
                <ListItemIcon style={{ minWidth: 40 }}>
                  <AccountBadgedIcon
                    alt={account.account_holder}
                    src={account.image_small || account.image}
                    isOwner={isAccountOwner(roles, status)}
                  />
                </ListItemIcon>
                <ListItemText primary={account.account_holder ?? account.email} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Popover>
  )
}

export { AccountsListPopover }
